import {
	createTypes,
	createAsyncAction,
} from '@flux';
import { mainPlatformSelectorsPack } from '@platform/selectors';


type ActionTypes = {
	FETCH_TENANT_ACCOUNT: string;
};

const types = createTypes<ActionTypes>([
	'FETCH_TENANT_ACCOUNT',
], 'PLATFORM');

const actions = {
	fetchTenantAccount: createAsyncAction(types.FETCH_TENANT_ACCOUNT)(
		(box, tenantID: number) => box.api.billingPack.billingService.fetchTenantAccount(tenantID),
		{
			cache: {
				asyncSelector: mainPlatformSelectorsPack.selectAsyncTenantAccount,
			},
		},
	) as (tenantID: number) => void,
};

export const mainPlatformActionsPack = {
	types,
	actions,
};
